var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppHeader'),_c('notifications',{attrs:{"position":"center right","classes":"kkk-notification"}}),_c('router-view'),_c('AppFooter'),_c('cookie-banner'),_c('BackToTop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }